import React from "react";
import { Link } from "react-router-dom";
import logo from "../images/tapes.png";

const Header = () => {
  return (
    <div className=" shadow ">
      <header className="   p-2 w-100   text-center  shadow  bgheader App-header text-white">
        <h3 className="reggae-one-regular">
          <Link to={"/"} className=" text-decoration-none">
            <img alt="logo" src={logo} height={"70px"}></img>
          </Link>
        </h3>
      </header>
    </div>
  );
};

export default Header;
